/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackView = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M9 2a1 1 0 0 0-.707.293l-6 6A1 1 0 0 0 2 9v12a1 1 0 0 0 1 1h12a1 1 0 0 0 .707-.293l6-6A1 1 0 0 0 22 15V3a1 1 0 0 0-1-1zm.414 14H14v4H5.414zM16 16h2.586L16 18.586zM4 10h4v4.586l-4 4zm4-4.586V8H5.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBackView as BackView };
